
import React from "react";
import "./OurServices.css"; // Import the CSS file

const OurServices = () => {
  return (
    <div className="page-wrapper">

      <div className="service-card">
        <h2 className="service-title">Stress and Anxiety Management</h2>
        <p className="service-description">
          Our counselors help you manage stress and anxiety through proven
          techniques like cognitive-behavioral therapy (CBT), mindfulness, and
          relaxation exercises. Learn how to control your emotions and regain
          balance. Feel empowered to overcome anxiety.
        </p>
      </div>

      <div className="service-card">
        <h2 className="service-title">Psychological Assessments</h2>
        <p className="service-description">
          We offer professional psychological assessments to better understand
          mental health conditions, cognitive abilities, and emotional well-being.
          Our evaluations help diagnose and guide treatment plans effectively.
          Understand yourself better with our comprehensive assessments.
        </p>
      </div>

      <div className="service-card">
        <h2 className="service-title">Child and Adolescent Therapy</h2>
        <p className="service-description">
          Our child and adolescent therapy programs support young individuals
          through challenges like behavioral issues, trauma, or emotional
          struggles. We use age-appropriate techniques to help them thrive.
          Empowering kids to overcome obstacles and build resilience.
        </p>
      </div>

      <div className="service-card">
        <h2 className="service-title">Personal Growth and Life Coaching</h2>
        <p className="service-description">
          Unlock your full potential with personal growth and life coaching. Our
          expert coaches guide you in setting goals, boosting confidence, and
          realizing your ambitions. Embrace change and create the life you desire.
        </p>
      </div>

      <div className="service-card">
        <h2 className="service-title">Relationship Counseling</h2>
        <p className="service-description">
          Strengthen your relationships through counseling tailored to couples
          and individuals. Whether dealing with communication issues or
          conflict resolution, we guide you to healthier, happier relationships.
          Build deeper connections and mutual understanding.
        </p>
      </div>

      <div className="service-card">
        <h2 className="service-title">Individual Counseling</h2>
        <p className="service-description">
          Our individual counseling sessions are designed to help you work
          through personal struggles. From grief to self-esteem issues, our
          compassionate counselors offer a safe space for healing and self-
          discovery. Explore your inner self and grow at your own pace.
        </p>
      </div>

      <div className="service-card">
        <h2 className="service-title">Group Therapy</h2>
        <p className="service-description">
          Group therapy fosters a supportive environment for sharing and
          learning from others with similar experiences. It’s a great way to
          build connections, offer mutual support, and heal together. Strengthen
          your emotional resilience in a group setting.
        </p>
      </div>

      <div className="service-card">
        <h2 className="service-title">Family Counseling</h2>
        <p className="service-description">
          Family counseling helps resolve conflicts, improve communication, and
          strengthen family bonds. We work with families to address issues such
          as parenting challenges, relationship struggles, or behavioral
          problems. Build a healthier family dynamic together.
        </p>
      </div>

      <div className="service-card">
        <h2 className="service-title">Mindfulness and Meditation</h2>
        <p className="service-description">
          Learn the art of mindfulness and meditation to enhance emotional
          well-being. Our experts teach techniques to manage stress, cultivate
          awareness, and improve focus. Achieve mental clarity and peace through
          mindfulness.
        </p>
      </div>

      <div className="service-card">
        <h2 className="service-title">Career Counseling</h2>
        <p className="service-description">
          Get guidance on career paths, job opportunities, and professional
          growth. Our career counseling services help you identify your strengths
          and match them with fulfilling careers. Let us guide you to a brighter
          professional future.
        </p>
      </div>
    </div>
  );
};

export default OurServices;
